import { createTheme } from '@mui/material'
import { common, grey } from '@mui/material/colors'

export const LightMode = {
  primary: {
    main: "#002e55"
  },
  secondary: {
    main: "#d2d3d5"
  },
  info: {
    main: "#65B32C"
  },
  success: {
    main: "#65B32C",
    contrastText: "#ffffff"
  },
  warning: {
    main: "#d4c268"
  },
  error: {
    main: "#ff5975"
  },
  price: {
    main: "#444CE7"
  },
  background: {
    default: grey[200],
    paper: grey[100],
  },
  text: {
    primary: grey[900],
    secondary: grey[600],
    disabled: grey[400],
  },
  divider: grey[200],
  action: {
    active: grey[600],
    hover: grey[300],
    disabledBackground: grey[300],
  }
}

export const StatusColor = {
  "1": grey[800],
  "2": LightMode.warning.main,
  "3": LightMode.success.main,
  "4": LightMode.error.main,
  "5": LightMode.primary.main,
}

export const LightTheme = createTheme({
  components: {
    MuiInput: {
      styleOverrides: {
        input: {
          "&::placeholder": {
            color: {
              main: LightMode.primary.main
            }
          }
        }
      },
    },
    MuiAvatar: {
      styleOverrides: {
        root: {
          backgroundColor: '#65B32C',
        }
      }
    },
    MuiListItemIcon: {
      styleOverrides: {
        root: {
          color: '#65B32C',
        }
      }
    }
  },
  palette: {
    primary: {
      50: '#65B32C',
      100: '#65B32C',
      200: '#65B32C',
      300: '#65B32C',
      400: '#65B32C',
      500: '#65B32C',
      600: '#65B32C',
      700: '#65B32C',
      800: '#65B32C',
      900: '#65B32C',
      A100: '#65B32C',
      A200: '#65B32C',
      A400: '#65B32C',
      A700: '#65B32C'
    },
    secondary: {
      50: '#d2d3d5',
      100: '#d2d3d5',
      200: '#d2d3d5',
      300: '#d2d3d5',
      400: '#d2d3d5',
      500: '#d2d3d5',
      600: '#d2d3d5',
      700: '#d2d3d5',
      800: '#d2d3d5',
      900: '#d2d3d5',
      A100: '#d2d3d5',
      A200: '#d2d3d5',
      A400: '#d2d3d5',
      A700: '#d2d3d5'
    },
    info: {
      50: '#65B32C',
      100: '#65B32C',
      200: '#65B32C',
      300: '#65B32C',
      400: '#65B32C',
      500: '#65B32C',
      600: '#65B32C',
      700: '#65B32C',
      800: '#65B32C',
      900: '#65B32C',
      A100: '#65B32C',
      A200: '#65B32C',
      A400: '#65B32C',
      A700: '#65B32C'
    },
    success: {
      50: '#65B32C',
      100: '#65B32C',
      200: '#65B32C',
      300: '#65B32C',
      400: '#65B32C',
      500: '#65B32C',
      600: '#65B32C',
      700: '#65B32C',
      800: '#65B32C',
      900: '#65B32C',
      A100: '#65B32C',
      A200: '#65B32C',
      A400: '#65B32C',
      A700: '#65B32C'
    },
    warning: {
      50: '#d4c268',
      100: '#d4c268',
      200: '#d4c268',
      300: '#d4c268',
      400: '#d4c268',
      500: '#d4c268',
      600: '#d4c268',
      700: '#d4c268',
      800: '#d4c268',
      900: '#d4c268',
      A100: '#d4c268',
      A200: '#d4c268',
      A400: '#d4c268',
      A700: '#d4c268'
    },
    error: {
      50: '#ff5975',
      100: '#ff5975',
      200: '#ff5975',
      300: '#ff5975',
      400: '#ff5975',
      500: '#ff5975',
      600: '#ff5975',
      700: '#ff5975',
      800: '#ff5975',
      900: '#ff5975',
      A100: '#ff5975',
      A200: '#ff5975',
      A400: '#ff5975',
      A700: '#ff5975'
    },
    background: {
      default: common.white,
      paper: common.white,
    },
    text: {
      primary: grey[900],
      secondary: LightMode.primary.main,
    },
    action: {
      active: LightMode.primary.main,
    },
  }
})